import { createFileRoute } from '@tanstack/react-router'
import ContactGeneral from 'Contact/components/Contact/Sections/ContactGeneral'

export const Route = createFileRoute('/contact/$contactId/details')({
    component: ContactGeneral,
})
